import { render, staticRenderFns } from "./ratemanagedialog.vue?vue&type=template&id=4530e49d&scoped=true&"
import script from "./ratemanagedialog.vue?vue&type=script&lang=js&"
export * from "./ratemanagedialog.vue?vue&type=script&lang=js&"
import style0 from "./ratemanagedialog.vue?vue&type=style&index=0&id=4530e49d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4530e49d",
  null
  
)

export default component.exports